import OrderList from './components/OrderList';
import './components/App.css';

function App() {
  return (
    <>
      <OrderList />
    </>
  );
}

export default App;
